// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
import {Version} from 'app/_interfaces/version.interface';
export const VERSION: Version = {
    "dirty": false,
    "raw": "26f8f3d",
    "hash": "26f8f3d",
    "distance": null,
    "tag": null,
    "semver": null,
    "suffix": "26f8f3d",
    "semverString": null,
    "version": "1.1.1",
    "buildDate": "2026-10-15T10:38:04.709Z"
};
/* tslint:enable */
